import React from "react";
import { t } from "../../../helpers/translator";

export default function lockTerminalTemplate() {
	return (
		<div className="ticket-results-view-p">
			{this.state.betCashoutChanged ? (
				<h3>
					{t(
						`The Cashout amount is changed to ${this.state.newPrice}. Would you like to cashout?`
					)}
				</h3>
			) : (
				<h3>{t(`Would you like to cashout ${this.props.price} ?`)}</h3>
			)}
			<div className="buttons-view-w-t">
				<ul>
					<li>
						<div className="separator-box-buttons-m">
							<button
								className="button-view-normal-m"
								onClick={this.sendCashoutAmount}
							>
								{t("Yes")}
							</button>
						</div>
					</li>
					<li>
						<div className="separator-box-buttons-m">
							<button
								className="button-view-normal-m trans-m"
								onClick={
									this.props.onClose?.() ||
									this.props.closePopup()
								}
							>
								{t("Cancel")}
							</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
}
